import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import {
    RewardsAvailableRewardsPageWidgetModalDefinition,
    RewardsJoinNowModalWidgetDefinition,
    RewardsQrCodeModalWidgetDefinition,
    RewardsVerifyAccountModalWidgetDefinition,
    RewardsWaysToEarnPageWidgetModalDefinition,
    RewardsWaysToSpendPageWidgetModalDefinition,
} from "@apps/rewards/constants/definitions";
import {
    rewardsAvailableRewardsPageWidgetModalToken,
    rewardsJoinNowModalWidgetToken,
    rewardsQrCodeModalWidgetToken,
    rewardsVerifyAccountModalWidgetToken,
    rewardsWaysToEarnPageWidgetModalToken,
    rewardsWaysToSpendPageWidgetModalToken,
} from "@apps/rewards/tokens";

import type { ModalConfig } from "./types";

export const modalConfig: ModalConfig = {
    [REWARDS_WIDGET_NAMES.REWARDS_VERIFY_ACCOUNT_MODAL_WIDGET]: {
        definition: RewardsVerifyAccountModalWidgetDefinition,
        token: rewardsVerifyAccountModalWidgetToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_JOIN_NOW_MODAL_WIDGET]: {
        definition: RewardsJoinNowModalWidgetDefinition,
        token: rewardsJoinNowModalWidgetToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_QR_CODE_MODAL_WIDGET]: {
        definition: RewardsQrCodeModalWidgetDefinition,
        token: rewardsQrCodeModalWidgetToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_EARN_PAGE_WIDGET_MODAL]: {
        definition: RewardsWaysToEarnPageWidgetModalDefinition,
        token: rewardsWaysToEarnPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_SPEND_PAGE_WIDGET_MODAL]: {
        definition: RewardsWaysToSpendPageWidgetModalDefinition,
        token: rewardsWaysToSpendPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_PAGE_WIDGET_MODAL]: {
        definition: RewardsAvailableRewardsPageWidgetModalDefinition,
        token: rewardsAvailableRewardsPageWidgetModalToken,
    },
} as const;
